// Toast.js
import { useEffect } from "react";
import "../styles/toast.css"; // If you have custom styling

const Toast = ({ message, type = "info", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.(); // Auto close after 3s
    }, 1000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toasted ${type}`}>
      {message}
    </div>
  );
};

export default Toast;
